import { AxiosInstance } from 'axios';
import {
  ChangeAccountAttributesProps,
  RequestBodyAccountResponse,
} from 'store/account/types';
import { CreateUserBody } from 'store/auth/types';

export const account = (ApiClient: () => Promise<AxiosInstance>) => {
  return {
    setAccountInfo: async () =>
      (await ApiClient()).get<RequestBodyAccountResponse>('/account'),
    changeAccountAttribute: async (body: ChangeAccountAttributesProps) => {
      return (await ApiClient()).put<RequestBodyAccountResponse>('/account', body);
    },
    createAccount: async (body: CreateUserBody) =>
      (await ApiClient()).post<RequestBodyAccountResponse>('/account', body),
  };
};
